import { keyBy } from "lodash";
import { useEffect } from "react";
import eventEmitter, { EVENTS } from "src/services/eventEmitter";

const useUpdateMemberListener = ({ mergePartialData }) => {
  useEffect(() => {
    const handler = ({ people, directGroups }) => {
      mergePartialData({
        members: keyBy(people, "aggregateId"),
        teams: keyBy(directGroups, "id"),
      });
    };

    eventEmitter.on(EVENTS.UPDATE_PEOPLE_AND_GROUPS, handler);

    return () => eventEmitter.off(EVENTS.UPDATE_PEOPLE_AND_GROUPS, handler);
  }, [mergePartialData]);
};

export default useUpdateMemberListener;
